// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import OthersSvg from '@rsuite/icon-font/lib/application/Others';
var Others = createSvgIcon({
  as: OthersSvg,
  ariaLabel: 'others',
  category: 'application',
  displayName: 'Others'
});
export default Others;